import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { HOST_URL } from '../../../config';
import './resetPassAdmin.css'
import axios from 'axios';

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    { id: 'user_id', label: 'User ID' },
    { id: 'name_of_user', label: 'User Name' },
    // { id: 'email', label: 'Email' },
    // { id: 'organisations', label: 'Organisations' },
    { id: 'resetPass', label: 'Reset' },
    // { id: 'roles', label: 'Roles' },
    // { id: 'country_code', label: 'Country Code' },
    // { id: 'company_code', label: 'Company Code' },
];

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };
    return (
        <TableHead>
            <TableRow>
                <TableCell align='center'>S. No.</TableCell>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
        display: 'none'
    },
}));


function ResetPassAdmin() {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [openalert, setOpenalert] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [severity, setSeverity] = useState('error');
    const [userData, setUserData] = useState([]);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name_of_user');
    const [searched, setSearched] = useState("");
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenalert(false);
    };
    useEffect(() => {
        getUserData();
    }, [])

    const getUserData = () => {
        setLoading(true);
        axios.get(`${HOST_URL}api/v1/AccountData/GetAllUser`).then(res => {
            setLoading(false);
            setUserData(res.data.users)
        }).catch(res => {
            console.log(res);
            setLoading(false);
            setOpenalert(true);
            setSeverity("error");
            setAlertText("Something went wrong!");
        })
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    if (loading) {
        return (
            <div className='loadingClass'>
                <CircularProgress size="1.5rem" />
            </div>
        )
    }

    return (
        <div className="userListComponent resetPassComp">
            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={openalert} autoHideDuration={3000} onClose={handleClose}>
                <Alert severity={severity} onClose={handleClose}>{alertText}</Alert>
            </Snackbar>
            <div className="statementBody userListBoard">
                <TableContainer style={{ height: '100%' }}>
                    <Table stickyHeader style={{ height: loading ? '100%' : '' }} id='tabletocopy'>
                        <EnhancedTableHead
                            classes={classes}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                        />
                        <TableBody>
                            {stableSort(userData, getComparator(order, orderBy))
                                .map((row, index) => {
                                    let count = index + 1
                                    return (
                                        <TableRow hover key={userData.user_id} className={row.is_active !== 'Y' ? 'notActive' : null}>
                                            <TableCell align='center'>{count}</TableCell>
                                            <TableCell title={row.user_id}>{row.user_id}</TableCell>
                                            <TableCell title={row.name_of_user}>{row.name_of_user}</TableCell>
                                            <TableCell title='Reset Password'><Button variant='contained' className=' shipmentheaderbutton'>Reset Password</Button></TableCell>
                                            {/* <TableCell title={row.email}>{row.email}</TableCell> */}
                                            {/* <TableCell title={row.organisations}>{row.organisations}</TableCell> */}
                                            {/* <TableCell title={row.rolls}>{row.rolls}</TableCell> */}
                                            {/* <TableCell title={row.country_code}>{row.country_code}</TableCell> */}
                                            {/* <TableCell title={row.company_code}>{row.company_code}</TableCell> */}
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    )
}

export default ResetPassAdmin
